import { render, staticRenderFns } from "./AssignmentAttempt.vue?vue&type=template&id=a46d45a6&scoped=true&"
import script from "./AssignmentAttempt.vue?vue&type=script&lang=js&"
export * from "./AssignmentAttempt.vue?vue&type=script&lang=js&"
import style0 from "./AssignmentAttempt.vue?vue&type=style&index=0&id=a46d45a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a46d45a6",
  null
  
)

export default component.exports